import React from "react";
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Typography,
  makeStyles,
  Card,
  CardContent,
  Modal,
} from "@material-ui/core";
import SideDrawer from "../Admin/Drawer";
import { gpColors } from "../../constants/colors";
import { useEffect, useRef, useState } from "react";
import { getCookie } from "../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { Grid } from "@material-ui/core";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import {
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AddProductValMOdal from "./AddProductValMOdal";
import Cookies from "js-cookie";
import api from "../Interceptors/axiosInstance";
// import RefreshIcon from '@mui/icons-material/Refresh';
// import RefreshIcon from "@mui/icons-material/Refresh";
import RefreshIcon from "@material-ui/icons/Refresh";
import { TextFormat } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    // paddingBottom: 20,
  },
  root: {
    padding: "2%",
    paddingTop: "1%",
    minHeight: "20px",
    marginTop: "20px",
  },
  dateRoot: {
    padding: "2%",
    minHeight: "20px",
    marginTop: "20px",
  },
  refreshIconBox: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    justifyContent: "center",
    alignItems: "center",
  },
  textFieldStyle: {
    width: "60%",
    height: "50px",
    [theme.breakpoints.only("sm")]: {
      width: "70%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    "& .MuiOutlinedInput-root": {
      height: "50px",
    },
  },
  scanButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff !important",
    // width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.only("sm")]: {
      width: "45%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  qrBoxContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "left",
    alignItems: "left",
  },
  scanner: {
    width: "40%",
    marginTop: "5%",
    position: "unset !important",
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    width: "15%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sd")]: {
      width: "60%",
    },
  },
  editLink: {
    color: "rgb(23, 94, 170)",
    cursor: "pointer",
    textDecoration: "none",
    fontSize: "0.875rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  totalRow: {
    fontWeight: "bold",
    fontSize: "16px",
  },
}));

export const Dashboard = () => {
  const [userData, setUserData] = useState({});
  const classes = useStyles();
  const [btnLoader, setBtnLoader] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [loader, setLoader] = useState(false);
  const [locScanData, setLocScanData] = useState([]);
  const [userScanData, setUserScanData] = useState([]);
  const [search, setSearch] = useState("");
  const [userScanSearch, setUserScanSearch] = useState("");
  const [openExport, setOpenExport] = useState(false);
  const [startExportDate, setStartExportDate] = useState(null);
  const [endExportDate, setEndExportDate] = useState(null);
  const [exportType, setExportType] = useState("locationWise");
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });
  const [validationModal, setValidationModal] = useState(false);
  function closeValidationModal() {
    setValidationModal(false);
  }
  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };
  const locHeadCells = [
    {
      name: "Ship to Location",
      selector: (row) => (row.shipToLoc ? row.shipToLoc : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total Boxes Scanned",
      selector: (row) => (row.totalScan ? row.totalScan : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total CBM",
      selector: (row) => (row.totalCbm ? row.totalCbm : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total Unit Qty",
      selector: (row) => (row.unitQty ? row.unitQty : "NA"),
      sortable: true,
      center: true,
    },
  ];

  const UserHeadCell = [
    {
      name: "User Name",
      selector: (row) => (row.userName ? row.userName : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total Boxes Scanned",
      selector: (row) => (row.totalScan ? row.totalScan : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total CBM",
      selector: (row) => (row.totalCbm ? row.totalCbm : "NA"),
      sortable: true,
      center: true,
    },
    {
      name: "Total Unit Qty",
      selector: (row) => (row.unitQty ? row.unitQty : "NA"),
      sortable: true,
      center: true,
    },
  ];

  // const getLoginInfoData = () => {
  //   const getValue = getCookie("guardPlus_user");
  //   console.log('dashboard get value: ', getValue)
  //   if (getValue !== null) {
  //     const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //     const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //     setUserData(userVal);
  //     setToken(userVal.loginInfo.data.jwt);
  //   }
  // };

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    // getLoginInfoData();
  }, []);

  useEffect(() => {
    handleLocationScanData();
    handleUsersScanData();

    const interval = setInterval(() => {
      handleLocationScanData();
      handleUsersScanData();
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const handleSearch = (start, end) => {
    console.log("start and end date", start, end);
    if (!start || !end) {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Please select both start and end dates.",
      });
      setLoader(false);
      return;
    } else if (start > end || end < start) {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Start date cannot be greater than end date.",
      });
      setLoader(false);
      return;
    }
    setStartDate(start);
    setEndDate(end);
    setLoader(true);
    handleLocationScanData();
    handleUsersScanData();
  };
  const handleClear = () => {
    setStartDate(null);
    setEndDate(null);
  };

  useEffect(() => {
    if (!startDate && !endDate) {
      handleLocationScanData();
      handleUsersScanData();
    }
  }, [startDate, endDate]);

  const handleLocationScanData = async () => {
    try {
      const formattedStartDate = startDate
        ? format(startDate, "yyyy-MM-dd")
        : null;
      const formattedEndDate = endDate ? format(endDate, "yyyy-MM-dd") : null;

      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/get-inward-scan-summary?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      console.log("dat3s: ", formattedStartDate, formattedEndDate);
      const resp = await api.get(
        `/get-inward-scan-summary?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      );
      const data = await resp.data;
      if (data.result === "success") {
        const resultData = data.resultData;
        if (Array.isArray(resultData) && resultData.length > 0) {
          setLocScanData(resultData);
        } else {
          setLocScanData([]);
        }
      } else {
        setLocScanData([]);
      }
      setLoader(false);
    } catch (e) {
      console.log("get-inward-scan-summary Error :- ", e);
    }
  };

  const handleUsersScanData = async () => {
    try {
      const formattedStartDate = startDate
        ? format(startDate, "yyyy-MM-dd")
        : null;
      const formattedEndDate = endDate ? format(endDate, "yyyy-MM-dd") : null;

      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/get-inward-scan-user-summary?startDate=${formattedStartDate}&endDate=${formattedEndDate}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      const resp = await api.get(
        `/get-inward-scan-user-summary?startDate=${formattedStartDate}&endDate=${formattedEndDate}`
      );
      const data = await resp.data;
      console.log("user dates data: ", formattedStartDate, formattedEndDate);
      console.log("user scan data response: ", data);
      if (data.result === "success") {
        const resultData = data.resultData;
        if (Array.isArray(resultData) && resultData.length > 0) {
          setUserScanData(resultData);
        } else {
          setUserScanData([]);
        }
      } else {
        setUserScanData([]);
      }
      setLoader(false);
    } catch (e) {
      console.log("get-inward-scan-summary Error :- ", e);
    }
  };

  const filteredLocData = locScanData?.filter(
    (item) =>
      item.shipToLoc?.toString().toLowerCase().includes(search.toLowerCase()) ||
      String(item.totalScan).includes(search) ||
      String(item.totalCbm).includes(search) ||
      String(item.unitQty).includes(search)
  );
  const calculateTotalRow = (data) => {
    if (!data || data.length === 0) return null;

    const totalBoxScan = data.reduce(
      (sum, row) => sum + Number(row.totalScan || 0),
      0
    );
    const totalCBM = data.reduce(
      (sum, row) => sum + Number(row.totalCbm || 0),
      0
    );
    const totalUnitQty = data.reduce(
      (sum, row) => sum + Number(row.unitQty || 0),
      0
    );
    return {
      shipToLoc: "Total",
      totalScan: totalBoxScan,
      totalCbm: totalCBM.toFixed(2),
      unitQty: totalUnitQty,
      isTotalRow: true,
    };
  };

  const totalRow = calculateTotalRow(filteredLocData);
  const locTableData = totalRow
    ? [...filteredLocData, totalRow]
    : filteredLocData;

  const filteredUserScanData = userScanData?.filter(
    (item) =>
      item.userName
        ?.toString()
        .toLowerCase()
        .includes(userScanSearch.toLowerCase()) ||
      String(item.totalScan).includes(userScanSearch) ||
      String(item.totalCbm).includes(userScanSearch) ||
      String(item.unitQty).includes(userScanSearch)
  );

  // const calculateTotalRow = (data) => {
  //   if (!data || data.length === 0) return null;

  //   const totalBoxScan = data.reduce(
  //     (sum, row) => sum + Number(row.totalScan || 0),
  //     0
  //   );
  //   const totalCBM = data.reduce(
  //     (sum, row) => sum + Number(row.totalCbm || 0),
  //     0
  //   );
  //   const totalUnitQty = data.reduce(
  //     (sum, row) => sum + Number(row.unitQty || 0),
  //     0
  //   );
  //   return {
  //     shipToLoc: "Total",
  //     totalScan: totalBoxScan,
  //     totalCbm: totalCBM.toFixed(2),
  //     unitQty: totalUnitQty,
  //     isTotalRow: true,
  //   };
  // };

  const totalUserRow = calculateTotalRow(filteredUserScanData);
  const userTableData = totalUserRow
    ? [...filteredUserScanData, totalUserRow]
    : filteredUserScanData;

  const handleStartExportDateChange = (date) => {
    setStartExportDate(date);
    if (endExportDate && date > endExportDate) {
      setEndExportDate(null);
    }
  };
  const handleExportClose = () => {
    setOpenExport(false);
    setStartExportDate(null);
    setEndExportDate(null);
    setExportType("locationWise");
  };

  const handleExport = async () => {
    if (!startExportDate || !endExportDate) {
      console.log("alert");
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Please select both start and end dates for export.",
      });
      return;
    }
    try {
      const startDate = startExportDate
        ? format(startExportDate, "yyyy-MM-dd")
        : null;
      const endDate = endExportDate
        ? format(endExportDate, "yyyy-MM-dd")
        : null;
      // const resp = await fetch(
      //   `${process.env.REACT_APP_API_ENDPOINT}/export-inward-scan-data-summary?startDate=${startDate}&endDate=${endDate}&exportType=${exportType}`,
      //   {
      //     method: "GET",
      //     headers: {
      //       Authorization: `Token ${userData.loginInfo.data.jwt}`,
      //       "Content-Type": "application/json",
      //     },
      //   }
      // );
      // if (resp.ok && resp.status !== 204) {
      //   const blob = await resp.blob();
      //   const url = window.URL.createObjectURL(blob);
      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = `InwardScanSummary.xlsx`;
      //   a.style.display = "none";
      //   document.body.appendChild(a);
      //   a.click();
      //   a.remove();
      //   window.URL.revokeObjectURL(url);
      // } else if (resp.status === 204) {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "No data found to generate Excel file.",
      //   });
      // } else {
      //   setAlert({
      //     ...alert,
      //     alertStatus: true,
      //     alertColor: "red",
      //     alertMessage: "An error occurred while exporting the data.",
      //   });
      // }
      const response = await api.get(
        `/export-inward-scan-data-summary?startDate=${startDate}&endDate=${endDate}&exportType=${exportType}`,
        {
          responseType: "blob",
        }
      );

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const dateOnly = new Date().toISOString().split("T")[0];
        a.download = `InwardScanSummary_${dateOnly}.xlsx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } else if (response.status === 204) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "No data found to generate Excel file.",
        });
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while exporting the data.",
        });
      }
      handleExportClose();
    } catch (error) {
      console.log("export inward-scan-summary error :--", error);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while exporting the data.",
      });
    }
  };
  console.log("startDate: ", startDate, "endDate: ", endDate);
  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="dashboard" />
      <main className={classes.content}>
        <Box style={{ display: "flex", justifyContent: "space-between" }}>
          <Box className={classes.refreshIconBox}>
            <Typography className={classes.title}>Dashboard</Typography>

            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={() => {
                handleLocationScanData();
                handleUsersScanData();
              }}
              style={{textTransform:'none'}}
            >
              Autorefreshes 60 sec
            </Button>
          </Box>

          <Button
            className={classes.exportButton}
            onClick={() => {
              setOpenExport(true);
            }}
          >
            {btnLoader ? <CircularProgress size={25} /> : "Export To Excel"}
          </Button>
        </Box>
        {/* date range card */}
        <Card className={classes.dateRoot}>
          <CardContent mt={0}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container spacing={3}>
                <Grid item xs={5}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="From Date"
                    format="MM/dd/yyyy"
                    value={startDate}
                    onChange={setStartDate}
                    disableFuture
                    fullWidth
                  />
                </Grid>
                <Grid item xs={5}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="To Date"
                    format="MM/dd/yyyy"
                    value={endDate}
                    minDate={startDate}
                    // disabled={!startDate}
                    onChange={setEndDate}
                    disableFuture
                    fullWidth
                  />
                </Grid>
                <Grid
                  item
                  xs={2}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handleSearch(startDate, endDate)}
                  >
                    Search
                  </Button>
                  <Button
                    style={{ marginLeft: 5 }}
                    variant="contained"
                    color="primary"
                    onClick={() => handleClear()}
                  >
                    Clear
                  </Button>
                </Grid>
              </Grid>
            </MuiPickersUtilsProvider>
          </CardContent>
        </Card>
        {/* location wise card */}
        <Card className={classes.root}>
          <CardContent mt={0}>
            <Box mt={0} pt={0}>
              <div>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      width: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                {/* Data Table */}
                <DataTable
                  columns={locHeadCells}
                  data={locTableData || []}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress size={30} color="inherit" />
                  }
                  noDataComponent={
                    <div style={{ color: "red" }}>Data Not Exist</div>
                  }
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                  conditionalRowStyles={[
                    {
                      when: (row) => row.isTotalRow,
                      style: {
                        backgroundColor: "#f5f5f5",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      },
                    },
                  ]}
                />
              </div>
            </Box>
            {/* <TableContainer style={{ maxHeight: 300, overflowY: "auto" }}>
              <Table
                style={{ borderRadius: "20px" }}
                stickyHeader
                aria-labelledby="tableTitle"
              >
                <TableHead>
                  <TableRow>
                    {locHeadCells.map((headCell) => (
                      <TableCell
                        align="center"
                        style={{
                          backgroundColor: gpColors.logoGray,
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                        key={headCell.id}
                      >
                        {headCell.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={locHeadCells.length} align="center">
                        <CircularProgress color="inherit" size={25} />
                      </TableCell>
                    </TableRow>
                  ) : locScanData && locScanData.length > 0 ? (
                    <>
                      {locScanData.map((item, index) => (
                        <TableRow
                          key={item.id}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#fff" : "#fafafa",
                          }}
                        >
                          <TableCell
                            align="center"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {item.shipToLoc}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {item.totalScan}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {item.totalCbm}
                          </TableCell>
                          <TableCell
                            align="center"
                            style={{ fontSize: "0.875rem" }}
                          >
                            {item.unitQty}
                          </TableCell>
                        </TableRow>
                      ))}
                      <TableRow
                        style={{
                          fontWeight: "bold",
                          backgroundColor: "#f5f5f5",
                        }}
                      >
                        <TableCell align="center" className={classes.totalRow}>Total</TableCell>
                        <TableCell align="center" className={classes.totalRow}>
                            {locScanData.reduce((sum, r) => sum + Number(r.totalScan || 0), 0)}
                        </TableCell>
                        <TableCell align="center" className={classes.totalRow}>
                          {locScanData
                            .reduce((sum, r) => sum + parseFloat(r.totalCbm), 0)
                            .toFixed(2)}
                        </TableCell>
                        <TableCell align="center" className={classes.totalRow}>
                          {locScanData.reduce((sum, r) => sum + Number(r.unitQty || 0), 0)}
                        </TableCell>
                      </TableRow>
                    </>
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={locHeadCells.length}
                        align="center"
                        style={{ color: "red" }}
                      >
                        Data Not Exist
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer> */}
          </CardContent>
        </Card>
        {/* userwise card */}
        <Card className={classes.root}>
          <CardContent mt={0}>
            <Box mt={0} pt={0}>
              <div>
                <Box
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {/* Search Bar */}
                  <input
                    type="text"
                    placeholder="Search..."
                    value={userScanSearch}
                    onChange={(e) => setUserScanSearch(e.target.value)}
                    style={{
                      marginBottom: "10px",
                      padding: "10px",
                      width: "300px",
                      border: "1px solid #ccc",
                      borderRadius: "4px",
                    }}
                  />
                </Box>
                {/* Data Table */}
                
                <DataTable
                  columns={UserHeadCell}
                  data={userTableData || []}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress size={30} color="inherit" />
                  }
                  noDataComponent={
                    <div style={{ color: "red" }}>Data Not Exist</div>
                  }
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                  conditionalRowStyles={[
                    {
                      when: (row) => row.isTotalRow,
                      style: {
                        backgroundColor: "#f5f5f5",
                        fontWeight: "bold",
                        fontSize: "0.9rem",
                      },
                    },
                  ]}
                />
                {/* <DataTable
                  columns={UserHeadCell}
                  data={filteredUserScanData || []}
                  progressPending={loader}
                  progressComponent={
                    <CircularProgress size={30} color="inherit" />
                  }
                  noDataComponent={
                    <div style={{ color: "red" }}>Data Not Exist</div>
                  }
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[5, 10, 20, 50, 100]}
                  highlightOnHover
                  striped
                  responsive
                  persistTableHead
                  customStyles={{
                    headCells: {
                      style: {
                        backgroundColor: gpColors.logoGray,
                        color: "#fff",
                        fontWeight: "bold",
                        justifyContent: "center",
                      },
                    },
                    rows: {
                      style: {
                        fontSize: "0.875rem",
                      },
                    },
                  }}
                /> */}
              </div>
            </Box>
            {/* <TableContainer style={{ maxHeight: 300, overflowY: "auto" }}>
              <Table
                style={{ borderRadius: "20px" }}
                stickyHeader
                aria-labelledby="tableTitle"
              >
                <TableHead>
                  <TableRow>
                    {UserHeadCell.map((headCell) => (
                      <TableCell
                        align="center"
                        style={{
                          backgroundColor: gpColors.logoGray,
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                        key={headCell.id}
                      >
                        {headCell.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loader ? (
                    <TableRow>
                      <TableCell colSpan={locHeadCells.length} align="center">
                        <CircularProgress color="inherit" size={25} />
                      </TableCell>
                    </TableRow>
                  ) : userScanData && userScanData.length > 0 ? (
                    userScanData.map((item, index) => (
                      <TableRow
                        key={item.id}
                        style={{
                          backgroundColor: index % 2 === 0 ? "#fff" : "#fafafa",
                        }}
                      >
                        <TableCell
                          align="center"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {item.userName}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {item.totalScan}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {item.totalCbm}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ fontSize: "0.875rem" }}
                        >
                          {item.unitQty}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell
                        colSpan={UserHeadCell.length}
                        align="center"
                        style={{ color: "red" }}
                      >
                        Data Not Exist
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer> */}
          </CardContent>
        </Card>
        <Divider />
      </main>
      {/* Export Modal */}
      <Modal
        open={openExport}
        onClose={handleExportClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            borderRadius: 10,
            boxShadow: 24,
            p: 4,
          }}
        >
          {" "}
          <IconButton
            aria-label="close"
            onClick={() => handleExportClose()}
            sx={(theme) => ({
              position: "absolute",
              right: 8,
              top: 8,
              color: theme.palette.grey[500],
            })}
          >
            <CloseIcon />
          </IconButton>
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="From Date"
                    format="MM/dd/yyyy"
                    value={startExportDate}
                    onChange={handleStartExportDateChange}
                    disableFuture
                    fullWidth
                  />
                </Grid>
                <Grid item xs={6}>
                  <KeyboardDatePicker
                    margin="normal"
                    label="To Date"
                    format="MM/dd/yyyy"
                    value={endExportDate}
                    minDate={startExportDate}
                    disabled={!startExportDate}
                    onChange={setEndExportDate}
                    disableFuture
                    fullWidth
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: "20px" }}>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                    value={exportType}
                    onChange={(e) => setExportType(e.target.value)}
                  >
                    <FormControlLabel
                      value="locationWise"
                      control={<Radio />}
                      label="Export Location Wise"
                      checked={exportType === "locationWise"}
                    />
                    <FormControlLabel
                      value="userWise"
                      control={<Radio />}
                      label="Export User Wise"
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
            </MuiPickersUtilsProvider>
          </Box>
          <Box display="flex" justifyContent="center" mt={4}>
            <Button
              onClick={handleExport}
              style={{
                backgroundColor: "#F22F46",
                color: "#fff",
                width: "70%",
              }}
            >
              Export
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* Validation modal and alert box for API results component */}
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
    </Box>
  );
};
